import React, { useState } from 'react';
import { Button } from '@ui';
import { Modal, ModalHeader, ModalBody, ModalFooter } from '@ui/molecules/Modal';
import TextInput from '@components/TextInput/TextInput';
import { translate } from '@utils/i18n';
const namespace = 'features.settings.ai_inspection_manager.grammar_and_style';
export default function AddTermModal({ isOpen, onClose, onAdd, modalType }) {
    const [term, setTerm] = useState('');
    const handleAdd = () => {
        if (term.trim()) {
            onAdd(term.trim());
            setTerm('');
            onClose();
        }
    };
    const handleClose = () => {
        setTerm('');
        onClose();
    };
    const titleKey = modalType === 'exclude' ? 'exclude_term_title' : 'include_term_title';
    const descriptionKey = modalType === 'exclude' ? 'exclude_term_description' : 'include_term_description';
    return (React.createElement(Modal, { isOpen: isOpen, onClose: handleClose, ariaLabelledBy: "add-term-modal-title" },
        React.createElement(ModalHeader, { title: translate(titleKey, { namespace }), titleId: "add-term-modal-title", onClose: handleClose }),
        React.createElement(ModalBody, null,
            React.createElement("div", { className: "add-term-modal__content" },
                React.createElement("p", { className: "add-term-modal__description" }, translate(descriptionKey, { namespace })),
                React.createElement(TextInput, { label: translate('term_or_abbreviation', { namespace }), value: term, onChange: (e) => setTerm(e.target.value), placeholder: " " }))),
        React.createElement(ModalFooter, null,
            React.createElement("button", { type: "button", className: "qmb-control", onClick: handleClose }, translate('cancel', { namespace: 'features.commons' })),
            React.createElement(Button, { onClick: handleAdd, variant: "primary", disabled: !term.trim() }, translate('add_term_button', { namespace })))));
}
